import { createBrowserRouter, Navigate, RouterProvider, type RouteObject } from 'react-router';
import { routes } from '~/shared/constants/routes';
import Pages from '~/pages';
import { BaseLayout, AppLayout } from './components';

export const createRoutes = (): RouteObject[] => {
    return [
        {
            element: <BaseLayout />,
            children: [
                {
                    element: <AppLayout variant='public' />,
                    children: [
                        {
                            path: routes.login,
                            element: <Pages.Login />,
                        },
                        {
                            path: routes.registration,
                            element: <Pages.Registration />,
                        },
                        {
                            path: routes.recover,
                            element: <Pages.Recover />,
                        },
                        {
                            path: routes['privacy-policy'],
                            children: [
                                {
                                    index: true,
                                    element: <Pages.PrivacyPolicy />,
                                },
                            ],
                        },
                    ],
                },
                {
                    element: (
                        <AppLayout
                            variant='app'
                            withHavbar
                        />
                    ),
                    children: [
                        {
                            index: true,
                            element: (
                                <Navigate
                                    to={`/${routes.payout}`}
                                    replace
                                />
                            ),
                        },
                        {
                            path: routes.payout,
                            element: <Pages.PayoutWork />,
                        },
                        {
                            path: routes['payout-history'],
                            element: <Pages.PayoutHistory />,
                        },
                        {
                            path: routes['payout-order'],
                            element: <Pages.PayoutOrder />,
                        },
                        {
                            path: routes.payin,
                            element: <Pages.PayinWork />,
                        },
                        {
                            path: routes['payin-history'],
                            element: <Pages.PayinHistory />,
                        },
                        {
                            path: routes['payin-order'],
                            element: <Pages.PayinOrder />,
                        },
                        {
                            path: routes.settings,
                            element: <Pages.Settings />,
                        },
                    ],
                },
                {
                    path: '*',
                    element: <Pages.NotFound />,
                },
            ],
        },
    ];
};

const router = createBrowserRouter(createRoutes());

export const Router = () => {
    return <RouterProvider router={router} />;
};
